export const resultHubFilters = {
  leagues: [
    { id: 'all', name: 'All Leagues' },
    { id: 'premier-league', name: 'Premier League' },
    { id: 'la-liga', name: 'La Liga' },
    { id: 'bundesliga', name: 'Bundesliga' },
  ],
  statuses: [
    { id: 'all', name: 'All Status' },
    { id: 'ongoing', name: 'Ongoing' },
    { id: 'finished', name: 'Finished' },
    { id: 'upcoming', name: 'Upcoming' },
    { id: 'postpond', name: 'Postponed'},
    { id: 'snapshot', name: 'Snapshots'}
  ],
};

export const resultHubMatches = [
  {
    id: 'premier-league',
    league: 'Premier League',
    kickoff: '18:00',
    fixtures: [
      {
        id: 'premier-bet365',
        bookmaker: 'Bet365',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '2 - 1',
      },
      {
        id: 'premier-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '1 - 1',
      }
    ]
  },
  {
    id: 'premier-league',
    league: 'Premier League',
    kickoff: '18:00',
    fixtures: [
      {
        id: 'premier-bet365',
        bookmaker: 'Bet365',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '2 - 1',
      },
      {
        id: 'premier-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '1 - 1',
      }
    ]
  },
  {
    id: 'premier-league',
    league: 'Premier League',
    kickoff: '18:00',
    fixtures: [
      {
        id: 'premier-bet365',
        bookmaker: 'Bet365',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '2 - 1',
      },
      {
        id: 'premier-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '1 - 1',
      }
    ]
  },
  {
    id: 'premier-league',
    league: 'Premier League',
    kickoff: '18:00',
    fixtures: [
      {
        id: 'premier-bet365',
        bookmaker: 'Bet365',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '2 - 1',
      },
      {
        id: 'premier-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '1 - 1',
      }
    ]
  },
  {
    id: 'premier-league',
    league: 'Premier League',
    kickoff: '18:00',
    fixtures: [
      {
        id: 'premier-bet365',
        bookmaker: 'Bet365',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '2 - 1',
        description : "Exciting match with both teams showing great skill and determination."
      },
      {
        id: 'premier-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Arsenal vs Chelsea',
        status: 'Ongoing',
        statusId: 'ongoing',
        score: '1 - 1',
      }
    ]
  },
  {
    id: 'la-liga',
    league: 'La Liga',
    kickoff: '21:00',
    fixtures: [
      {
        id: 'laliga-bet365',
        bookmaker: 'Bet365',
        matchup: 'Real Madrid vs Barcelona',
        status: 'Finished',
        statusId: 'finished',
        score: '3 - 2',
        description : "Exciting match with both teams showing great skill and determination."
      },
      {
        id: 'laliga-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Real Madrid vs Barcelona',
        status: 'Finished',
        statusId: 'finished',
        score: '2 - 2',
      }
    ]
  },
  {
    id: 'bundesliga',
    league: 'Bundesliga',
    kickoff: '19:30',
    fixtures: [
      {
        id: 'bundesliga-bet365',
        bookmaker: 'Bet365',
        matchup: 'Bayern Munich vs Dortmund',
        status: 'Upcoming',
        statusId: 'upcoming',
        score: '-',
      },
      {
        id: 'bundesliga-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Bayern Munich vs Dortmund',
        status: 'Upcoming',
        statusId: 'upcoming',
        score: '-',
      }
    ]
  },
  {
    id: 'bundesliga2',
    league: 'Bundesliga 2',
    kickoff: '19:30',
    fixtures: [
      {
        id: 'bundesliga-bet365',
        bookmaker: 'Bet365',
        matchup: 'Bayern Munich vs Dortmund',
        status: 'Upcoming',
        statusId: 'upcoming',
        score: '-',
      },
      {
        id: 'bundesliga-william-hill',
        bookmaker: 'William Hill',
        matchup: 'Bayern Munich vs Dortmund',
        status: 'Upcoming',
        statusId: 'upcoming',
        score: '-',
      }
    ]
  }
];

